/** Esigibilità IVA */
export enum SDIChargeabilityType {
  /** Immediata */
  Immediate = 'I',
  /** Differita */
  Deferred = 'D',
  /** Scissione dei Pagamenti */
  Split = 'S'
}
